import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { IconMenuDown, IconAccountCircle, IconCamera } from '@sfx/icons';
import cx from 'classnames';
import styles from './style/userDropdownMenu.module.css.json';

var prefix = 'sfx-react-ui-user-dropdown';

var UserDropdownMenu = /*#__PURE__*/function (_Component) {
  _inherits(UserDropdownMenu, _Component);

  var _super = _createSuper(UserDropdownMenu);

  function UserDropdownMenu() {
    var _this;

    _classCallCheck(this, UserDropdownMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      menuOpen: false,
      showDropDownBottom: false,
      showDropDownTop: false
    });

    _defineProperty(_assertThisInitialized(_this), "dropdownToggle", function () {
      _this.setState({
        menuOpen: !_this.state.menuOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMenuScroll", function (e) {
      var dropDownWrap = e.currentTarget;

      if (dropDownWrap && dropDownWrap.scrollHeight > dropDownWrap.offsetHeight) {
        _this.setState({
          showDropDownBottom: true,
          showDropDownTop: true
        });
      } else {
        _this.setState({
          showDropDownBottom: false,
          showDropDownTop: false
        });
      }

      if (dropDownWrap.scrollTop > 0) {
        _this.setState({
          showDropDownTop: true
        });
      } else {
        _this.setState({
          showDropDownTop: false
        });
      }

      if (dropDownWrap && dropDownWrap.scrollTop >= dropDownWrap.scrollHeight - dropDownWrap.offsetHeight) {
        _this.setState({
          showDropDownBottom: false
        });
      } else {
        _this.setState({
          showDropDownBottom: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickMenu", function (item) {
      item.onClick && item.onClick();

      _this.dropdownToggle();
    });

    _defineProperty(_assertThisInitialized(_this), "onClickPreferenceItem", function () {
      var preferenceItem = _this.props.preferenceItem;
      preferenceItem && preferenceItem.onClick && preferenceItem.onClick();

      _this.dropdownToggle();
    });

    _defineProperty(_assertThisInitialized(_this), "onClickCamera", function () {
      var onCamera = _this.props.onCamera;
      onCamera && onCamera();

      _this.dropdownToggle();
    });

    _defineProperty(_assertThisInitialized(_this), "onClickSignOut", function () {
      var onSignOut = _this.props.onSignOut;
      onSignOut && onSignOut();

      _this.dropdownToggle();
    });

    return _this;
  }

  _createClass(UserDropdownMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          showDropDownTop = _this$state.showDropDownTop,
          showDropDownBottom = _this$state.showDropDownBottom,
          menuOpen = _this$state.menuOpen;
      var _this$props = this.props,
          theme = _this$props.theme,
          showCamera = _this$props.showCamera,
          role = _this$props.role,
          preferenceItem = _this$props.preferenceItem,
          avatarUrl = _this$props.avatarUrl,
          givenName = _this$props.givenName,
          familyName = _this$props.familyName,
          menuItems = _this$props.menuItems,
          onSignOut = _this$props.onSignOut,
          onCamera = _this$props.onCamera;
      var fullName = givenName && familyName && "".concat(givenName, " ").concat(familyName);
      var avatarGivenName = givenName && givenName.substring(0, 1).toUpperCase() || '';
      var avatarFamilyName = familyName && familyName.substring(0, 1).toUpperCase() || '';
      var Avatar = avatarUrl ? /*#__PURE__*/React.createElement("img", {
        className: styles.avatar,
        src: avatarUrl
      }) : /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-avatar ").concat(styles.avatar)
      }, "".concat(avatarGivenName).concat(avatarFamilyName));
      var dom = /*#__PURE__*/React.createElement(Dropdown, {
        className: "".concat(prefix, "-header-dropdown ").concat(styles.userDropdown),
        isOpen: this.state.menuOpen,
        toggle: this.dropdownToggle
      }, /*#__PURE__*/React.createElement(DropdownToggle, {
        tag: "div",
        onClick: this.dropdownToggle,
        "data-toggle": "dropdown",
        "aria-expanded": menuOpen,
        className: styles.userDropdown
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.userGroup
      }, Avatar, /*#__PURE__*/React.createElement("span", {
        className: cx("".concat(prefix, "-userName"), styles.userName)
      }, fullName), /*#__PURE__*/React.createElement(IconMenuDown, {
        size: 16,
        className: styles.icon,
        color: '#fff'
      }))), /*#__PURE__*/React.createElement(DropdownMenu, {
        className: styles.userDropdownMenu,
        right: true
      }, /*#__PURE__*/React.createElement("div", {
        onScroll: function onScroll(e) {
          return _this2.onMenuScroll(e);
        },
        className: cx(styles.userDropdownMenuInnerWrap, _defineProperty({}, styles.userDropdownMenuInnerWrapMarginRight, showDropDownTop || showDropDownBottom))
      }, showDropDownTop && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-dropdown-top")
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.userDropdownAvatar
      }, /*#__PURE__*/React.createElement("div", {
        className: cx("".concat(prefix, "-userAvatar"), styles.userAvatar)
      }, avatarUrl ? /*#__PURE__*/React.createElement("img", {
        src: avatarUrl
      }) : /*#__PURE__*/React.createElement(IconAccountCircle, {
        size: 96,
        className: 'icon'
      }), showCamera && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-userAvatarCameraIcon"),
        onClick: this.onClickCamera
      }, /*#__PURE__*/React.createElement(IconCamera, {
        size: 16,
        color: '#fff'
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles.userNameArea
      }, /*#__PURE__*/React.createElement("span", {
        className: cx(styles.userNameItem, "".concat(prefix, "-userNameItem")),
        title: fullName
      }, fullName), /*#__PURE__*/React.createElement("span", {
        className: cx(styles.userProfession, "".concat(prefix, "-userProfession")),
        title: role
      }, role), preferenceItem && /*#__PURE__*/React.createElement("div", {
        className: cx(styles.userPreference, "".concat(prefix, "-userPreference")),
        onClick: this.onClickPreferenceItem
      }, preferenceItem.name), /*#__PURE__*/React.createElement("button", {
        className: cx("".concat(prefix, "-button"), styles.logOutButton),
        onClick: this.onClickSignOut
      }, 'Sign Out'))), menuItems && menuItems.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: cx(styles.itemsWrap, "".concat(prefix, "-itemsWrap"))
      }, menuItems.map(function (item, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: cx("".concat(prefix, "-dropdown-item"), styles.dropdownItem),
          onClick: function onClick() {
            _this2.onClickMenu(item);
          }
        }, item.name);
      }))), showDropDownBottom && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-dropdown-bottom")
      })));
      return theme ? /*#__PURE__*/React.createElement("span", {
        className: 'sfx-react-ui-theme',
        "data-theme": theme
      }, dom) : dom;
    }
  }]);

  return UserDropdownMenu;
}(Component);

_defineProperty(UserDropdownMenu, "defaultProps", {
  showCamera: true
});

export default UserDropdownMenu;